/**
 * Calculates the sum of array elements based on a selector function
 */
export const sumBy = <T>(array: T[], selector: (item: T) => number): number => {
  return array.reduce((sum, item) => sum + selector(item), 0)
}
